<template>
    <div>
        <p class="timeline-talks">{{ message }}</p>

        <tags
            v-if="blockTags"
            :status-type="blockTags.rating"
            :tag-icon="blockTags.icon"
            :tag-heading="blockTags.heading"
        ></tags>
    </div>
</template>

<script>
import tags from '@/components/Tags.vue'
export default {
    components: {
        tags,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: ['details'],
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        message() {
            return 'Unlock alert.'
        },
        blockTags() {
            if (this.details.currentObj) {
                return {
                    rating: this.details.currentObj.riskRatingStatus,
                    icon: 'icon-graph',
                    heading: this.details.currentObj.riskRatingStatus,
                }
            }
            return ''
        },
    },
}
</script>
